 
export const Footer = () => {
    return (
      <div>
        <footer>
          <p>Check all the projects... let me know what kind of work you're looking for</p>
          <div><i class="far fa-copyright"></i>
            <p>Created by Rob.Jason</p>
          </div>
        </footer>
      </div>
    )
  }

  export default Footer;